export const removeAccents = (str: string) => {
  const from = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÇç",
    to = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuucc",
    mapping: { [key: string]: string } = {};

  for (let i = 0, j = from.length; i < j; i++)
    mapping[from.charAt(i)] = to.charAt(i);

  const ret = [];
  for (let i = 0, j = str.length; i < j; i++) {
    const c = str.charAt(i);
    if (mapping.hasOwnProperty(str.charAt(i))) ret.push(mapping[c]);
    else ret.push(c);
  }
  return ret.join("");
};

export const normalizeUrl = (url: string) => {
  return encodeURIComponent(removeAccents(url));
};

export const capitalize = (s: string) => {
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const allowOnlyNumber = (text: string): string => {
  let formatedText = text;
  if (text && text.length > 0) {
    formatedText = text.replace(/[^0-9]*/g, "").replace(/(\..*)\./g, "$1");
  }
  return formatedText;
};
